import React, { memo, useMemo } from "react";
import { ReactionFragment, ReactionType } from "gql/graphql";
import { Text, HStack } from "@chakra-ui/react";
import colors from "app/colors";
import ReactionsAvatarGroup from "modules/messaging/_shared/reactions-avatar-group";

interface IProps {
  reactions: ReactionFragment[];
  color?: string;
}

const MessageFileReactions = ({ reactions, color = colors.white }: IProps) => {
  const reactionTypes = useMemo(
    () =>
      reactions.reduce((acc, reaction) => {
        const reactionType = reaction.type as ReactionType;
        if (!acc.includes(reactionType)) {
          acc.push(reactionType);
        }
        return acc;
      }, [] as ReactionType[]),
    [reactions],
  );

  if (reactions.length === 0) {
    return null;
  }

  return (
    <HStack spacing={1}>
      <ReactionsAvatarGroup reactionTypes={reactionTypes} />
      <Text fontSize={11} color={color} fontWeight={600}>
        {reactions.length}
      </Text>
    </HStack>
  );
};

export default memo(MessageFileReactions);
